import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';

import StartupLoader from 'containers/StartupLoader';

const PrivateRoute = ({ component: Component, isAuthed, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthed ? (
          <Component {...props} />
        ) : (
          <StartupLoader {...props} />
        )
      }
    />
  );
}

function mapStateToProps(state, ownProps) {
  return {
    isAuthed: state.auth.isAuthed
  }
}

export default withRouter(connect(mapStateToProps)(PrivateRoute))



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js